import { HttpErrorResponse } from "@angular/common/http";
import { inject, Injectable, Injector } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ToastMessageOptions } from "primeng/api";

@Injectable({
  providedIn: "root",
})
export class ErrorMessageService {
  private injector = inject(Injector);

  buildWarnMessageWithDetail(
    errorResponse: HttpErrorResponse,
  ): ToastMessageOptions {
    let detail: string = errorResponse.error?.detail;
    if (!detail || detail.trim().length === 0) {
      detail = this.injector.get(TranslateService).instant("Settings error");
    }

    return this.buildMessage(
      "warn",
      this.injector.get(TranslateService).instant("Warning"),
      detail,
      errorResponse.error?.uuid,
    );
  }

  buildErrorMessageWithDetail(
    errorResponse: HttpErrorResponse,
  ): ToastMessageOptions {
    let title = errorResponse.error?.title;
    if (!title) {
      title = errorResponse.error?.summary;
    }
    if (!title) {
      title = this.injector.get(TranslateService).instant("Error");
    }

    let detail: string = errorResponse.error?.detail;
    if (!detail || detail.trim().length === 0) {
      detail = this.injector.get(TranslateService).instant("Server error");
    }

    return this.buildMessage("error", title, detail, errorResponse.error?.uuid);
  }

  buildErrorMessageWithTitleAndViolations(
    errorResponse: HttpErrorResponse,
  ): ToastMessageOptions {
    const summary = errorResponse.error?.title;
    const uuid = errorResponse.error?.uuid;

    let detail = "";
    errorResponse.error.violations.forEach((element) => {
      detail += `${element.message}\n`;
    });
    if (detail.length > 0) {
      detail = detail.slice(0, -1);
    }

    return this.buildMessage("error", summary, detail, uuid);
  }

  buildMessage(
    severity: string,
    summary: string,
    detail: string,
    uuid: string,
  ): ToastMessageOptions {
    const detailWithUuid = uuid ? detail.concat("\n\n", uuid) : detail;

    return {
      severity: severity,
      summary: summary,
      detail: detailWithUuid,
    };
  }
}
